import Vue from 'vue'
import VueRouter from 'vue-router'
import DataSet from '../views/DataSet.vue'
import Map from '../views/Map.vue'
import Login from '../views/Login.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Login,
  },
  {
    path: '/dataSet',
    component: DataSet
  },
  {
    path: '/map',
    component: Map
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
